/**
* Benefit List JS
* -----------------------------------------------------------------------------
*
* All the JS for the Benefit List component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {

    className: 'benefits-list',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.benefits-list' ).each( function( key, component ) {
        const leftSplide = new Splide( $( component ).find( '.left-marquee__slider' )[0], {
          direction: 'ttb',
          type: 'loop',
          pagination: false,
          arrows: false,
          gap: '12px',
          height: '658px',
          autoWidth: true,
          autoHeight: true,
          pauseOnHover: false,
          pauseOnFocus: false,
          autoScroll: {
            speed: 0.5,
          },
          breakpoints: {
            1070: {
              direction: 'ltr',
              autoHeight: true,
              height: '200px',
            },
          },
        } );

        const rightSplide = new Splide( $( component ).find( '.right-marquee__slider' )[0], {
          direction: 'ttb',
          type: 'loop',
          pagination: false,
          arrows: false,
          gap: '12px',
          height: '658px',
          autoHeight: true,
          pauseOnHover: false,
          pauseOnFocus: false,
          autoScroll: {
            speed: -0.5,
          },
          breakpoints: {
            1024: {
              destroy: false,
            },
          },
        } );

        leftSplide.mount( {AutoScroll} );
        rightSplide.mount( {AutoScroll} );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'benefits-list', COMPONENT );
} )( app );
